// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	url: 'https://api.stage.tomglobal.org/api/v1',


	// tom
	s3BucketName: 'tom-prod-new',
	s3BucketRegion: 'eu-west-1',
	s3IdentityId: 'd107546a-fe70-43fc-9ef7-60752626f4b1',
	apiVersion: '2006-03-01',

	// default challenge id for the challenge section in documentation
	tomGlobalChallengeId: '67c9bc45e99c2900136042c5'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
